module.exports = __webpack_public_path__ + "static/media/Bukit.bf275c82.webp";